import React from 'react'
import { Container, Row, Col, Table, Modal, Form, Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import { ThreeDotSpinner } from "../loader";
import swal from "sweetalert";
import { apiService } from '../../service/api.service';
import { getImageUrl, tokenAddress } from '../../config/config';
import Pagination from "react-js-pagination";

const Cryptogiftstore = () => {
    const [cryptoGiftList, setCryptoGiftList] = useState([])
    const [isEdit, setIsEdit] = useState(false);
    const [editTokenId, setEditTokenId] = useState(null);
    const [limit, setLimit] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [page, setPage] = useState(0);
    const initailFormData = {
        tokenImage: "",
        token: "",
        quantity: "",
        points: "500",
        contractAddress: "",
        tokenAmount: ""
    };
    const [formData, setFormData] = useState(initailFormData);
    const [error, setError] = useState({
        token_image: "",
        token: "",
        quantity: "",
        points: "",
        contractAddress: "",
        tokenAmount: ""
    })

    const checkValidation = () => {
        let valid = true;
        const errors = {};
        if (!formData.tokenImage) {
            errors.token_image = "Token image is required";
            valid = false;
        }
        if (!formData.token.trim()) {
            errors.token = "Token is required";
            valid = false;
        }

        if (!formData.quantity.trim()) {
            errors.quantity = "Please enter quantity";
            valid = false;
        }

        if (!formData.points.trim()) {
            errors.points = "Please enter points";
            valid = false;
        }
        if (!formData.contractAddress) {
            errors.contractAddress = "Please enter contract address";
            valid = false;
        }
        if (!formData.tokenAmount) {
            errors.tokenAmount = "Please enter token amount";
            valid = false;
        }

        setError(errors);
        return valid;
    };


    const handleAddToken = async () => {
        if (!checkValidation()) return;

        try {
            const form = new FormData();
            form.append("gift_image", formData.tokenImage);
            form.append("name", formData.token);
            form.append("quantity", formData.quantity);
            form.append("points", formData.points);
            form.append("tokenAmount", formData.tokenAmount);
            form.append("contractAddress", formData.contractAddress);
            const proTokens = ["fartcoin", "pengu", "vine"];

            // Check if formData.token matches any of them
            if (proTokens.includes(formData.token?.toLowerCase())) {
                form.append("is_for_pro", true);
               } 



            const response = await apiService.addCryptoGift(form);
            fetchCryptoGifts()
            setFormData(initailFormData);
            setShowAdd(false);
            console.log("Token added successfully!", response);
        } catch (error) {
            console.error(error);
        }
    };

    const handleUpdateToken = async () => {
        if (!checkValidation()) return;

        try {
            const form = new FormData();
            form.append("gift_image", formData.tokenImage);
            form.append("name", formData.token);
            form.append("quantity", formData.quantity);
            form.append("points", formData.points);
            form.append("tokenAmount", formData.tokenAmount);
            form.append("contractAddress", formData.contractAddress);
            const response = await apiService.updateCryptoGift(editTokenId, form);
            fetchCryptoGifts()
            setIsEdit(false);
            setShowAdd(false);
            console.log("Token updated successfully!", response);
        } catch (error) {
            console.error(error);
        }
    };

    // const handleDeleteToken = async () => {
    //     try {
    //         await apiService.deleteCryptoGift(editTokenId);
    //         fetchCryptoGifts(page);
    //         handleCloseDelete()
    //     } catch (error) {
    //         console.error("Delete failed:", error)
    //     }
    // }

    const handleDeleteToken = async () => {
        try {
            const confirmDelete = await swal({
                title: "Are you sure?",
                text: "Do you really want to delete this token? This action cannot be undone.",
                icon: "warning",
                buttons: ["Cancel", "Yes, delete it!"],
                dangerMode: true,
            });

            if (!confirmDelete) {
                await swal("Cancelled", "Your token was not deleted.", "info");
                return;
            }

            await apiService.deleteCryptoGift(editTokenId);
            await swal("Deleted!", "Your token has been deleted successfully.", "success");
            fetchCryptoGifts(page);
        } catch (error) {
            console.error("Delete failed:", error);
            await swal("Delete Failed", error?.response?.data?.message || error?.message || "Something went wrong.", "error");
        }
    };



    useEffect(() => {
        fetchCryptoGifts(page)
    }, [])

    const fetchCryptoGifts = async (page = 0) => {
        try {
            const response = await apiService.cryptoGiftList(page + 1);
            setCryptoGiftList(response.data.data);
            const { currentPage, itemsPerPage, totalItems } = response.data.pagination;
            setPage(currentPage - 1);
            setLimit(itemsPerPage);
            setTotalItems(totalItems);
            console.log("<<<<<<<<<<<<<fetchCryptoGifts>>>>>>>>>>>", response);

        } catch (error) {
            console.error(error);
        }
    };

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber - 1);
        fetchCryptoGifts(pageNumber - 1)
    };



    // ----Add Modal--->>
    const [showAdd, setShowAdd] = useState(false);

    const handleCloseAdd = () => {
        setShowAdd(false)
        setFormData(initailFormData)
        setError({
            token_image: "",
            token: "",
            quantity: "",
            points: "",
            contractAddress: "",
            tokenAmount: ""
        })
    };
    const handleShowAdd = (item) => {
        const isEditing = item && item._id;

        if (isEditing) {
            setIsEdit(true);
            setEditTokenId(item._id);
            setFormData({
                tokenImage: item.gift_image || "",
                token: item.name || "",
                quantity: item.quantity?.toString() || "",
                points: item.points?.toString() || "",
                contractAddress: item.gift_contract_address || "",
                tokenAmount: item.gift_token_amount?.toString() || "",
            });
        } else {
            setIsEdit(false);
            setEditTokenId(null);
            setFormData(initailFormData);
        }

        setShowAdd(true);
    };



    //   ----Edit Modal--->>
    const [showDelete, setShowDelete] = useState(false);

    const handleCloseDelete = () => setShowDelete(false);
    const handleShowDelete = (id) => {
        setEditTokenId(id);
        setShowDelete(true)
    };

    return (
        <>
            {/* {loading ? <ThreeDotSpinner /> : ""}  */}
            <div className="dashboard-main-area">
                <Container fluid>
                    <div className="dashboard-area-heading management-heading">
                        <Row className="row justify-content-center align-items-center mb-3">
                            <Col md={12} lg={11}>
                                <div className="heading-top-area">
                                    <h2 className="align-self-center m-0">Crypto Gift Store</h2>
                                    <div class="export-csv-btn add-btn-area me-2"><button type="button" class="btn btn-unset" onClick={handleShowAdd}><i class="fa fa-plus" aria-hidden="true"></i> Add</button></div>
                                </div>
                            </Col>

                        </Row>
                        <Row className="pb-4 justify-content-center">
                            <Col md={12} lg={11}>
                                <div className="availabilit-section">
                                    <Table responsive="sm" className="UserListTable">
                                        <thead>
                                            <tr>
                                                <th>Sr. No.</th>
                                                <th>Token Name</th>
                                                <th>Contract Address</th>
                                                <th>Quantity</th>
                                                <th>Token Redemption</th>
                                                <th>Points</th>
                                                <th>Token Amount</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cryptoGiftList.length > 0 ? cryptoGiftList.map((cryptoGift, index) => (
                                                <tr>
                                                    <td>{page * limit + index + 1}</td>
                                                    <td className='tokenName'>{cryptoGift?.name?.length > 20 ? `${cryptoGift.name.slice(0, 20)}...` : cryptoGift?.name}
                                                        {cryptoGift?.name?.length > 20 && <span className='token_tool'>{cryptoGift?.name}</span>}
                                                    </td>
                                                    <td>{cryptoGift?.gift_contract_address ? cryptoGift?.gift_contract_address : "-"}</td>
                                                    <td>{cryptoGift?.quantity}</td>
                                                    <td>{cryptoGift?.redemption_quantity ? cryptoGift?.redemption_quantity : '-'}</td>
                                                    <td>{cryptoGift?.points}</td>
                                                    <td>{cryptoGift?.gift_token_amount ? cryptoGift?.gift_token_amount : "-"}</td>
                                                    <td>
                                                        <div className="view-eye-area">
                                                            <div className="d-flex align-items-center">
                                                                <div class="edit-pencil">
                                                                    <button onClick={() => handleShowAdd(cryptoGift)} role='button' className='bg-transparent'>
                                                                        <i className="fa fa-pencil text-white"></i>
                                                                    </button>
                                                                </div>
                                                                <div className="del-icon">
                                                                    <i class="fa fa-trash-o text-white" role='button' onClick={() => handleDeleteToken(cryptoGift._id)}></i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>)) :
                                                (
                                                    <tr className="no-dat-found-box">
                                                        <td colSpan={8}>
                                                            <img
                                                                src={
                                                                    require("../../assets/images/no-data.svg")
                                                                        .default
                                                                }
                                                                alt="da"
                                                            />
                                                            <h3 className="text-center text-light">
                                                                No data found
                                                            </h3>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </Table>
                                </div>
                            </Col>
                        </Row>
                    </div>

                </Container>
                {cryptoGiftList?.length > 0 && totalItems > 12 && (
                    <Pagination
                        activePage={page + 1}
                        itemsCountPerPage={limit}
                        totalItemsCount={totalItems}
                        pageRangeDisplayed={5}
                        onChange={handlePageChange}
                        prevPageText="Prev"
                        nextPageText="Next"
                    />
                )}
            </div>
            {/* --Add Modal---- */}
            <Modal
                className="add-pediction-area"
                show={showAdd}
                onHide={handleCloseAdd}
                backdrop="static"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {isEdit ? "Edit Token" : "Add Token"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="pb-3">
                    <div className="row row-cols-md-12">
                        <form className="">
                            <div className="mb-2">
                                <label className="form-label">Token Image</label>
                                <div className="common-image-area">
                                    <div className={error.token_image ? "upload-image-area input-error" : "upload-image-area"}>
                                        <input type="file"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                    setFormData((prevData) => ({
                                                        ...prevData,
                                                        tokenImage: file,
                                                    }));
                                                    setError((prevData) => ({ ...prevData, token_image: "" }));
                                                }
                                            }}
                                        />

                                        {formData.tokenImage && (
                                            <img src={
                                                formData.tokenImage instanceof File
                                                    ? URL.createObjectURL(formData.tokenImage)
                                                    : getImageUrl(formData.tokenImage)
                                            } alt="Token Preview" height={100} />
                                        )}
                                        <i className="fa fa-plus" aria-hidden="true" />{" "}
                                    </div>
                                </div>
                            </div>
                            <div className="mb-2">
                                <label className="form-label">
                                    Token <span>*</span>
                                </label>
                                <input
                                    maxLength={100}
                                    className="form-control "
                                    type="text"
                                    defaultValue=""
                                    value={formData.token}
                                    onChange={(e) => {
                                        setFormData((prevData) => ({
                                            ...prevData,
                                            token: e.target.value
                                        }));
                                        setError((prevData) => ({
                                            ...prevData,
                                            token: "",
                                        }))
                                    }}
                                />
                                <span className="text-danger">{error.token && <p>{error.token}</p>}</span>
                            </div>
                            <div className="mb-2">
                                <label className="form-label">
                                    Contract Address <span>*</span>
                                </label>
                                <input
                                    maxLength={100}
                                    className="form-control "
                                    type="text"
                                    defaultValue=""
                                    value={formData.contractAddress}
                                    onChange={(e) => {
                                        setFormData((prevData) => ({
                                            ...prevData,
                                            contractAddress: e.target.value
                                        }));
                                        setError((prevData) => ({
                                            ...prevData,
                                            contractAddress: "",
                                        }))
                                    }}
                                />
                                <span className="text-danger">{error.contractAddress && <p>{error.contractAddress}</p>}</span>
                            </div>
                            <div className="mb-2">
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <label className="form-label">
                                            Quantity<span>*</span>
                                        </label>
                                        <input
                                            maxLength={100}
                                            className="form-control "
                                            type="number"
                                            min={1}
                                            defaultValue=""
                                            value={formData.quantity}
                                            onChange={(e) => {
                                                const rawValue = e.target.value;
                                                if (
                                                    rawValue === "" ||
                                                    (!rawValue.startsWith("-") && Number(rawValue) > 0)
                                                ) {
                                                    setFormData((prevData) => ({
                                                        ...prevData,
                                                        quantity: rawValue,
                                                    }));

                                                    setError((prevData) => ({
                                                        ...prevData,
                                                        quantity: "",
                                                    }));
                                                }
                                            }}
                                        />
                                        <span className="text-danger">{error.quantity && <p>{error.quantity}</p>}</span>
                                    </div>

                                    <div className='col-md-6'>
                                        <label className="form-label">
                                            Points<span>*</span>
                                        </label>
                                        <input
                                            maxLength={100}
                                            className="form-control "
                                            type="number"
                                            defaultValue=""
                                            min={1}
                                            value={formData.points}
                                            onChange={(e) => {
                                                const rawValue = e.target.value;
                                                if (
                                                    rawValue === "" ||
                                                    (!rawValue.startsWith("-") && Number(rawValue) > 0)
                                                ) {
                                                    setFormData((prevData) => ({
                                                        ...prevData,
                                                        points: rawValue,
                                                    }));

                                                    setError((prevData) => ({
                                                        ...prevData,
                                                        points: "",
                                                    }));
                                                }
                                            }}
                                        />
                                        <span className="text-danger">{error.points && <p>{error.points}</p>}</span>
                                    </div>

                                    <div className='col-md-6'>
                                        <label className="form-label">
                                            Token Amount<span>*</span>
                                        </label>
                                        <input
                                            maxLength={100}
                                            className="form-control "
                                            type="number"
                                            min={1}
                                            defaultValue=""
                                            value={formData.tokenAmount}
                                            onChange={(e) => {
                                                const rawValue = e.target.value;
                                                if (
                                                    rawValue === "" ||
                                                    (!rawValue.startsWith("-") && Number(rawValue) > 0)
                                                ) {
                                                    setFormData((prevData) => ({
                                                        ...prevData,
                                                        tokenAmount: rawValue,
                                                    }));

                                                    setError((prevData) => ({
                                                        ...prevData,
                                                        tokenAmount: "",
                                                    }));
                                                }
                                            }}
                                        />
                                        <span className="text-danger">{error.tokenAmount && <p>{error.tokenAmount}</p>}</span>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={isEdit ? handleUpdateToken : handleAddToken}>Save</Button>
                    <Button className="close-btn-bottom" onClick={handleCloseAdd}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* --Edit Modal new---- */}
            <Modal
                className="add-pediction-area"
                show={showDelete}
                onHide={handleCloseDelete}
                backdrop="static"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Delete Token
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="pb-3">
                    <div className="row row-cols-md-12">
                        <h4>Are you sure want to delete this Token?</h4>

                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleDeleteToken}>Delete</Button>
                    <Button className="close-btn-bottom" onClick={handleCloseDelete}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default Cryptogiftstore
